import Tabela from "../../Componentes/Utils/Tabela"
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { formatCPF } from "../../Funcoes/FormatCPF";
import { formatarData } from "../../Funcoes/FormatarData";
import styled from "styled-components";
import GenericHeader from "../../Componentes/GenericHeader";
import Filters from "../../Componentes/Utils/Filters";
import FilterContainer from "../../Componentes/Utils/FilterContainer";
import Stats from "../../Componentes/Utils/Stats";
import { formatarValorBR } from "../../Funcoes/FormatarValorBR";
import { useModal } from "../../contexts/ModalContext";
import Overlay from "../../Componentes/Overlay";
import SideMenu from "../../Componentes/SideMenu";
import SideMenuBtn from "../../Componentes/SideMenuBtn";
import ModalNewAso from "./ModalNewAso";
import ModalExamesLista from "./ModalExamesLista";
import ClinicasModal from "./ClinicasModal";
import { VerifyPermission } from '../../Funcoes/VerifyPermission/'
import { AuthContext } from "../../Auth/AuthProvider";

import useApi from "../../hooks/useApi";
const LineStatus = styled.tr`
    color: ${props => props.status === 'atrasado' ? '#ff1919' : props.status === 'vencendo' ? '#e04700' : '#000000'} !important;
    &:nth-child( even ){
        background-color: #f2f2f2 !important;
    }
    &:nth-child( odd ) {
        background-color: #ebebeb  !important;
    }
    &:hover {
        background-color: #d9d9d9 !important;
    }
`
const DivStats = styled.div`
    display: flex;
    flex-direction: column;
    margin: auto;
    text-align: center;
    & h3 {
        margin: 7px 0;
    }
    & p {
        margin: 2px 0;
    }
`

const ColunaCell = styled.td`
    text-align: ${({ align }) =>
        align === "left" ? "left" : align === "right" ? "right" : "center"} !important;
`

const BodyContent = () => {
    const api = useApi();


    const { openModal, isModalOpen, closeModal } = useModal();

    const { user } = useContext(AuthContext)

    const [loading, setLoading] = useState(true);
    const [examesOcupacionais, setExamesOcupacionais] = useState([]);
    const [examesOcupacionaisFilter, setExamesOcupacionaisFilter] = useState([]);

    const getExamesOcupacionais = async () => {

        setLoading(true);

        try {

            const { data } = await api.get('/Painel/API/ASO/GetAsoList/');
            console.log(data);

            setExamesOcupacionais(data);
            setExamesOcupacionaisFilter(data);

        } catch (error) {

            console.error(error);

        } finally {

            setLoading(false);

        }

    }

    useEffect(() => {

        getExamesOcupacionais();

    }, [])

    const centroCustoOptions = useMemo(() => [...new Set(examesOcupacionais.map((obj) => obj.obra))].sort(), [examesOcupacionais]);
    const funcoesOptions = useMemo(() => [...new Set(examesOcupacionais.map((obj) => obj.funcao))].sort(), [examesOcupacionais]);

    const [colabName, setColabName] = useState('');
    const [cpf, setCpf] = useState('');
    const [centroCusto, setCentroCusto] = useState([]);
    const [funcao, setFuncao] = useState([]);
    const [tipoAso, setTipoAso] = useState([]);
    const [status, setStatus] = useState([]);
    const [dataInicial, setDataInicial] = useState('');
    const [dataFinal, setDataFinal] = useState('');

    const statusMap = {
        "VENCIDO": "atrasado",
        "A VENCER": "vencendo",
        "PENDENTE": "pendente",
        "VÁLIDO": "valido"
    };

    const statusLabels = Object.fromEntries(
        Object.entries(statusMap).map(([label, value]) => [value, label])
    );

    const handleFilter = useCallback(() => {
        setExamesOcupacionaisFilter(
            examesOcupacionais.filter((item) => {
                const nome = !colabName || item.nome.toLowerCase().includes(colabName.toLowerCase());
                const cpfFilter = !cpf || item.cpf.includes(cpf.replace(/\D/g, ''));

                const obra = !centroCusto.length || centroCusto.some(obj => (item.obra || '').includes(obj.value));
                const funcaoFilter = !funcao.length || funcao.some(obj => (item.funcao || '').includes(obj.value));
                const aso = !tipoAso.length || tipoAso.some(obj => (item.aso || '').includes(obj.value));
                const statusFilter =
                    !status.length ||
                    status.some(obj => statusMap[obj.value] === (item.status || ''));

                const dataIniOk = !dataInicial || (item.data && new Date(item.data) >= new Date(dataInicial));
                const dataFimOk = !dataFinal || (item.data && new Date(item.data) <= new Date(dataFinal));

                return nome && cpfFilter && obra && funcaoFilter && aso && statusFilter && dataIniOk && dataFimOk;
            })
        );
    }, [examesOcupacionais, colabName, cpf, centroCusto, funcao, tipoAso, status, dataInicial, dataFinal]);

    useEffect(() => {

        setLinhasTabela(100);

        if (tabelaRef.current) {
            tabelaRef.current.scrollTop = 0;
        }

        handleFilter();

    }, [handleFilter]);


    const openNewAso = () => {
        closeModal();
        openModal("newAsoModal");
    }

    const openExames = () => {

        closeModal();
        openModal("listaExamesModal");

    }

    const openClinica = () => {

        closeModal();
        openModal("clinicasModal");

    }

    const [linhasTabela, setLinhasTabela] = useState(100);

    const tabelaRef = useRef(null)

    useEffect(() => {

        const element = tabelaRef.current;

        if (!element) return;

        const handleScroll = () => {

            const { scrollTop, scrollHeight, clientHeight } = element;

            if (scrollTop + clientHeight >= scrollHeight - 10) {
                setLinhasTabela((prev) => prev + 100);
            }

        };

        element.addEventListener("scroll", handleScroll);

        return () => {
            element.removeEventListener("scroll", handleScroll);
        };

    }, []);

    const [idAso, setIdAso] = useState(null);

    const openEditAso = (id) => {
        setIdAso(id);
        openModal("newAsoModal");
    }

    const closeAso = () => {
        setIdAso(null);
        closeModal();
    }

    const [ loadingExcel, setLoadingExcel ] = useState( false );

    const exportExcel = async () => {

        const ids = examesOcupacionaisFilter.map( e => e.id );
        
        try{

            setLoadingExcel( true );

            const response = await api.post('/Painel/API/ASO/GenerateRelatorio/', { ids }, {
                responseType: "blob",
                withCredentials: true,
            })

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'relatorio.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        }catch( e ){
        
            console.error( e );

        }finally{

            setLoadingExcel( false );

        }

    }

    return (
        <>
            <GenericHeader>
                <Filters columns={4} >
                    <FilterContainer
                        type="text"
                        placeholder="COLABORADOR..."
                        valor={colabName}
                        changeFunc={(value) => setColabName(value)}
                    />
                    <FilterContainer
                        type="text"
                        placeholder="CPF..."
                        valor={formatCPF(cpf)}
                        changeFunc={(value) => setCpf(value)}
                        maxLength={14}
                    />
                    <FilterContainer
                        type="select"
                        placeholder="CENTRO CUSTO..."
                        options={centroCustoOptions}
                        optType={'obj'}
                        changeFunc={(value) => setCentroCusto(value)}
                    />
                    <FilterContainer
                        type="select"
                        placeholder="FUNÇÃO..."
                        options={funcoesOptions}
                        optType={'obj'}
                        changeFunc={(value) => setFuncao(value)}
                    />
                    <FilterContainer
                        type="select"
                        placeholder="TIPO DO ASO..."
                        options={[
                            "ADMISSIONAL",
                            "DEMISSIONAL",
                            "MUDANÇA DE FUNÇÃO",
                            "PERIÓDICO",
                            "RETORNO AO TRABALHO"
                        ]}
                        optType={'obj'}
                        changeFunc={(value) => setTipoAso(value)}
                    />
                    <FilterContainer
                        type="select"
                        placeholder="STATUS..."
                        options={[
                            "A VENCER",
                            "PENDENTE",
                            "VENCIDO",
                            "VÁLIDO"
                        ]}
                        optType={'obj'}
                        changeFunc={(value) => setStatus(value)}
                    />
                    <FilterContainer
                        type="date"
                        valor={dataInicial}
                        changeFunc={(value) => setDataInicial(value)}
                    />
                    <FilterContainer
                        type="date"
                        valor={dataFinal}
                        changeFunc={(value) => setDataFinal(value)}
                    />
                </Filters>
                <Stats>
                    <DivStats>
                        <h3>TOTAL: {examesOcupacionaisFilter.length}</h3>
                        <p>VENCIDOS: {examesOcupacionaisFilter.filter(obj => obj.status === 'atrasado').length}</p>
                        <p>A VENCER: {examesOcupacionaisFilter.filter(obj => obj.status === 'vencendo').length}</p>
                        <p>VALOR TOTAL: {formatarValorBR(examesOcupacionaisFilter.reduce((acc, obj) => acc + parseFloat(obj.valor), 0))}</p>
                    </DivStats>
                </Stats>
            </GenericHeader>
            <Tabela loading={loading} ref={tabelaRef} >
                <thead>
                    <tr>
                        <th>NOME</th>
                        <th>CPF</th>
                        <th>FUNÇÃO</th>
                        <th>TIPO ASO</th>
                        <th>CLÍNICA</th>
                        <th>CENTRO CUSTO</th>
                        <th>DATA</th>
                        <th>VALIDADE</th>
                        <th>VALOR</th>
                        <th>STATUS</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        examesOcupacionaisFilter.slice(0, linhasTabela).map((aso) => (
                            <LineStatus onClick={() => openEditAso(aso.identifier)} key={aso.id} status={aso.status}>
                                <ColunaCell align="left" >{aso.nome}</ColunaCell>
                                <ColunaCell align="center" >{formatCPF(aso.cpf)}</ColunaCell>
                                <ColunaCell align="left" >{aso.funcao}</ColunaCell>
                                <ColunaCell align="center" >{aso.aso}</ColunaCell>
                                <ColunaCell align="left" >{aso.clinica}</ColunaCell>
                                <ColunaCell align="left" >{aso.obra}</ColunaCell>
                                <ColunaCell align="center" >{formatarData(aso.data)}</ColunaCell>
                                <ColunaCell align="center" >{aso.data_validade ? formatarData(aso.data_validade) : '-'}</ColunaCell>
                                <ColunaCell align="right" >R$ {formatarValorBR(aso.valor)}</ColunaCell>
                                <ColunaCell align="center" >{statusLabels[aso.status]}</ColunaCell>
                            </LineStatus>
                        ))
                    }
                </tbody>
            </Tabela>
            {
                isModalOpen('asoSidebar') && (
                    <Overlay state={true} changeContent={closeModal} >
                        <SideMenu>
                            {
                                VerifyPermission(user, { modulo: "rh", submodulo: "exames-ocupa", funcao: "edicao_aso" }) && (
                                    <>
                                        <SideMenuBtn
                                            button="CLÍNICAS"
                                            clickFunc={openClinica}
                                        />
                                        <SideMenuBtn
                                            button="LISTA DE EXAMES"
                                            clickFunc={openExames}
                                        />
                                    </>
                                )
                            }
                            <SideMenuBtn
                                button="RELATORIO"
                                isLoading={ loadingExcel }
                                clickFunc={ exportExcel }
                            />
                            <SideMenuBtn
                                button="SOLICITAR ASO"
                                clickFunc={openNewAso}
                            />
                        </SideMenu>
                    </Overlay>
                )
            }
            {
                isModalOpen('newAsoModal') && (
                    <ModalNewAso
                        fetchSuccess={getExamesOcupacionais}
                        closeAso={closeAso}
                        idAsoEdit={idAso}
                    />
                )
            }
            {
                isModalOpen('listaExamesModal') && (
                    <ModalExamesLista />
                )
            }
            {
                isModalOpen('clinicasModal') && (
                    <ClinicasModal />
                )
            }
        </>
    )
}

export default BodyContent;